import { createSlice } from '@reduxjs/toolkit';

const FJSliceFaceSwap = createSlice({
    name: 'faceSwap',
    initialState: {
        originUploadImageInfo: {},
        targetUploadImageInfo: {},
        targetCurLoadName: '',
        originCurLoadName: '',
        mobileStep: 0,
    },

    reducers: {
        setSliceOriginUploadImageInfo: (state, action) => {
            state.originUploadImageInfo = action.payload;
        },
        setSliceTargetUploadImageInfo: (state, action) => {
            state.targetUploadImageInfo = action.payload;
        },
        setSliceTargetCurLoadName: (state, action) => {
            state.targetCurLoadName = action.payload;
        },
        setSliceOriginCurLoadName: (state, action) => {
            state.originCurLoadName = action.payload;
        },
        setSliceMobileStep: (state, action) => {
            state.mobileStep = action.payload;
        },
    },
});

export const {
    setSliceOriginUploadImageInfo,
    setSliceTargetUploadImageInfo,
    setSliceTargetCurLoadName,
    setSliceOriginCurLoadName,
    setSliceMobileStep,
} = FJSliceFaceSwap.actions;

export default FJSliceFaceSwap.reducer;
